export default __webpack_public_path__ + "static/media/mask-of-art.87ae4b06.jpg";